import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/resenas/button-play-icon.webp")